import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const ReimagineIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="smallIcon" clipPath="url(#clip0_988_8786)">
        <path id="Vector" d="M4 2.38281V8.38281" stroke={fillColor || '#6C6C6C'} strokeLinecap="round" strokeLinejoin="round" />
        <path
          id="Vector_2"
          d="M4 14.3828C4 10.5169 7.16607 7.38281 11.0714 7.38281H13M13 7.38281L9 3.38281M13 7.38281L9 11.3828"
          stroke={fillColor || '#6C6C6C'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_988_8786">
          <rect width="16" height="16" fill={fillColor || 'white'} transform="translate(0 0.382812)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { ReimagineIcon };
